import { useCallback, useEffect } from 'react';
import { pop } from '@app/components/DialogPopup';
import { useNavigate } from 'react-router-dom';
import { signify } from 'react-signify';
import { MessageUtils } from '../errors';
import { IErrorResponseItem, IHttpCommonErrorIndicator } from '../http';
import { BusinessExceptionProps, Command } from './ErrorHandleModel';

export const initCommonError: IHttpCommonErrorIndicator<IErrorResponseItem> = {
  command: Command.NONE,
  path: '',
  error: undefined,
};

export const commonErrorSignal = signify(initCommonError);

export const useCommonErrorHandler = () => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    commonErrorSignal.set(initCommonError);
  }, []);
  useEffect(() => {
    // watch() trả về unsubscribe function - cần cleanup khi unmount
    const unwatch = commonErrorSignal.watch((info) => {
      if (info.command === Command.NONE) {
        return;
      }

      if (info.command === Command.NAVIGATE) {
        const { path: navigateTo, statusCode } = info;

        navigateTo && navigate(navigateTo, { state: { statusCode } });
        return;
      }

      // Handling show Dialog message error
      const { error } = info;
      if (!error) {
        return;
      }

      const errorDialogProps = {
        errorCode: error.code,
        errorMsg: error.message,
        type: MessageUtils.getTypeFromCode(error.body?.[0]?.code ?? error.code),
      } as BusinessExceptionProps;

      pop[errorDialogProps.type as keyof typeof pop](errorDialogProps.errorMsg)
        .onYes(handleClick)
        .onNo({ callback: handleClick });
    });

    // Cleanup watcher khi component unmount
    return () => {
      (unwatch as (() => void) | undefined)?.();
    };
  }, [navigate, handleClick]);
};
